import { HomeLayoutOptionContent } from './HomeLayoutOptionContent';
export default HomeLayoutOptionContent;